import { WebhookKey } from "./EWebhookKey";

export const webhookKeyToFieldMap: Partial<
  Record<WebhookKey, { test: string; prod: string }>
> = {
  [WebhookKey.VERIFF_DECISION]: {
    test: "test_employee_veriff_decision_webhook",
    prod: "employee_veriff_decision_webhook",
  },
  [WebhookKey.PERSONA_VERIFICATION]: {
    test: "test_worker_persona_verification_webhook",
    prod: "worker_persona_verification_webhook",
  },
  [WebhookKey.WALLET_TRANSACTION]: {
    test: "test_wallet_transaction_webhook",
    prod: "wallet_transaction_webhook",
  },
  [WebhookKey.TRANSACTION_RETURNED]: {
    test: "test_transaction_returned_webhook",
    prod: "transaction_returned_webhook",
  },
};
